<template>
    <v-chip
        class="deepi-chip"
        :class="classes"
    >
		<template
			v-if="props.prependIcon"
			#prepend
		>
			<v-icon
				:size="12"
				:icon="props.prependIcon"
			/>
		</template>
        <p
            v-if="props.text"
            v-title-clamp
            class="text-body-s text-medium text-ellipsis"
        >
            {{ props.text }}
        </p>
    </v-chip>
</template>

<script setup lang="ts">
import { computed } from 'vue';

export interface DeepiChipProps {
    color?: 'edit' | 'error' | 'primary' | 'secondary' | 'success' | 'warning';
    prependIcon?: string;
    text?: string;
};

const props = withDefaults(defineProps<DeepiChipProps>(), {
    color: 'primary'
});

const classes = computed((): string[] => {
    return [props.color];
});
</script>

<style scoped lang="scss">
@use 'DeepiChip.scss';
</style>